import { delay } from 'lodash';
import { useState } from 'react';
import { ScrollableTabPanel } from '../../../../../components';
import { Service } from '../../../../../entities';
import { Stepper, CommonAreasSteps, StepperContent } from './CommonAreasSteps';

interface CommonAreaPanelProps {
  visible: boolean;
  service: Service;
  file: File | null;
  handleSetSelectedService: (value: Partial<Service>) => void;
  handleUpload: (file: File | null) => void;
  onClickClose: () => void;
  onSubmit: (value: Service) => void;
}

export const CommonAreaPanel = ({
  visible,
  service,
  file,
  handleSetSelectedService,
  onClickClose,
  onSubmit,
  handleUpload,
}: CommonAreaPanelProps): JSX.Element => {
  const stepsLength = Object.keys(CommonAreasSteps).length;

  const [activeStep, setActiveStep] = useState(0);
  const [shouldValidate, setShouldValidate] = useState(false);

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleNext = () => {
    setShouldValidate(true);
  };

  const handleClickClose = () => {
    onClickClose();
    handleUpload(null);
    setActiveStep(0);
  };

  const onValidateStep = (value: boolean) => {
    if (value) {
      /** Delaying time to execute set should validate on child */
      delay(() => {
        if (activeStep === stepsLength - 1) {
          onSubmit(service);

          handleClickClose();
          return;
        }

        setActiveStep(activeStep + 1);
      }, 60);
    }
  };

  return (
    <ScrollableTabPanel
      visible={visible}
      title="Dados do serviço"
      hiddenSubmit
      onClickClose={handleClickClose}
      loading={false}
      customSubmit={<Stepper activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} />}
    >
      <StepperContent
        activeStep={activeStep}
        service={service}
        shouldValidate={shouldValidate}
        file={file}
        handleUpload={handleUpload}
        handleSetSelectedService={handleSetSelectedService}
        setShouldValidate={(value: boolean) => setShouldValidate(value)}
        validate={onValidateStep}
      />
    </ScrollableTabPanel>
  );
};

export default CommonAreaPanel;
